import { useMe } from "@chotca/api-client";
import { Navigate } from "react-router-dom";
import { CreateOrgForm } from "./create-org-form";

export function OnboardingEmployerPage() {
  const me = useMe();

  if (me.isLoading) return null;
  if (!me.data) return <Navigate to="/login" replace />;
  if (me.data.memberships.length > 0)
    return <Navigate to="/dashboard" replace />;

  return <CreateOrgForm />;
}
